import React from 'react';
import App from './App';
import { createRoot } from 'react-dom/client';

import reportWebVitals from './reportWebVitals';
import i18next from 'i18next';
import { i18nextConfiguration } from './i18n/config/i18next-configuration';
import { I18nextProvider } from 'react-i18next';
import storeConfiguration from "./store/configureStore";
import { BrowserRouter } from 'react-router-dom';

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

i18next.init(i18nextConfiguration)

const container = document.getElementById('root');
const root = createRoot(container);
const { store, Provider } = storeConfiguration();

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      </Provider>
    </I18nextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
